import{a as e}from"./chunk-4VLJCJJM.js";import{m as o}from"./chunk-HBP5N4FR.js";o();var I=()=>{let{isLoggedIn:n}=e();return n};export{I as a};
//# sourceMappingURL=chunk-JBVENEHE.js.map
